<div class="apps-book-widget-multi-city-mobile">
  <div class="mc-mobile-container-row-1">
    <div class="mc-mobile-container-row-1__item trip-type-field">
      <mach-select
        id="trip-type-field"
        [title]="''"
        [content]="bookWidgetFields.tripTypesField.dropdownOptions"
        [disabled]="bookWidgetFields.tripTypesField.disable"
        (action)="
          onDropdownSelectionChange($event, bookWidgetFieldUpdateTypes.tripType)
        "
        [icon]="{
          alt: '',
          src: '/content/dam/delta-applications/sitewide/capability/flight-shop/images/multi-trip-icon.svg',
          show: true
        }"
        [ariaLabel]="bookWidgetAem.tripTypesField.tripTypeAriaLabel"
      ></mach-select>
    </div>

    <div class="mc-mobile-container-row-1__item passenger-field">
      <mach-select
        [title]="''"
        [content]="bookWidgetFields.passengerField.dropdownOptions"
        [disabled]="bookWidgetFields.passengerField.disable"
        (action)="
          onDropdownSelectionChange(
            $event,
            bookWidgetFieldUpdateTypes.passenger
          )
        "
        [icon]="{
          alt: bookWidgetAem.passengerField.passenger,
          src: '/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg',
          show: true
        }"
        [ariaLabel]="bookWidgetAem.passengerField.passengerAriaLabel"
      ></mach-select>
    </div>
  </div>
  <div class="mc-mobile-container-row-2">
    <div
      class="mc-mobile-flight-container"
      *ngFor="
        let airportItem of bookWidgetFields.airportsField.airports;
        let i = index
      "
    >
      <div class="mc-mobile-flight-index-label">
        {{ bookWidgetAem.airportsField.flight }} {{ i + 1 }}
      </div>
      <div class="mc-mobile-flight-route-picker">
        <idp-multicity-route-picker
          [routeIndex]="i"
          [routePickerContent]="{
            origin: {
              title:
                bookWidgetFields.airportsField.airports[i].fromAirportcode ===
                ''
                  ? bookWidgetAem.airportsField.from
                  : '',
              subtitle: bookWidgetAem.airportsField.yourOrigin
            },
            destination: {
              title:
                bookWidgetFields.airportsField.airports[i].toAirportcode === ''
                  ? bookWidgetAem.airportsField.to
                  : '',
              subtitle: bookWidgetAem.airportsField.yourDestination
            },
            ariaLabels: {
              origin:
                bookWidgetAem.airportsField.originAriaLabel +
                (bookWidgetFields.airportsField.airports[i].fromAirportcode
                  .length
                  ? ' ' +
                    bookWidgetFields.airportsField.airports[i].fromAirportcode +
                    ', ' +
                    bookWidgetFields.airportsField.airports[i].fromCity
                  : ''),
              swapArrow: bookWidgetAem.airportsField.swapAriaLabel,
              departure:
                bookWidgetAem.airportsField.departureAriaLabel +
                (bookWidgetFields.airportsField.airports[i].toAirportcode.length
                  ? ' ' +
                    bookWidgetFields.airportsField.airports[i].toAirportcode +
                    ', ' +
                    bookWidgetFields.airportsField.airports[i].toCity
                  : '')
            }
          }"
          [routePickerCities]="{
            destinationCode:
              bookWidgetFields.airportsField.airports[i].toAirportcode,
            destinationName: bookWidgetFields.airportsField.airports[i].toCity,
            destinationRegion: '',
            originCode:
              bookWidgetFields.airportsField.airports[i].fromAirportcode,
            originName: bookWidgetFields.airportsField.airports[i].fromCity,
            originRegion: ''
          }"
          [routePickerError]="
            bookWidgetFields.airportsField.fieldErrorInfo?.routePickerField
          "
          [recentSearchList]="recentSearchList"
          [savedSearchList]="savedSearchList"
          [searchModalTabs]="searchModalTabs"
          [isFullscreen]="isFullscreen"
          [predictiveSearchData]="predictiveSearchData"
          (swapClicked)="swapClicked.emit(i)"
          (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
          (searchModalEvent)="searchModalEvent.emit($event)"
        ></idp-multicity-route-picker>
      </div>
      <div class="mc-mobile-flight-date-picker dates-field">
        <idp-flight-date-picker
          [selectedTripType]="bookWidgetFields.tripTypesField.selectedTripType"
          [selectedRange]="bookWidgetFields.datesField.dates[i]"
          [bookWidgetAem]="bookWidgetAem"
          [datepickerConfig]="datepickerConfig"
          [fieldErrorInfo]="bookWidgetFields.datesField.fieldErrorInfo?.[i]"
          (action)="
            onDateSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.datesChange,
              i
            )
          "
        ></idp-flight-date-picker>
      </div>
      <div class="mc-mobile-flight-connection-picker">
        <idp-connection-picker
          class="connection-airport-picker"
          [routeIndex]="i"
          [placeholder]="bookWidgetAem.airportsField.connectionLabel"
          [connection]="{
            connectionCity: airportItem.connectionCity ?? '',
            connectionAirport: airportItem.connectionAirport ?? ''
          }"
          [recentSearchList]="recentSearchList"
          [savedSearchList]="savedSearchList"
          [searchModalTabs]="searchModalTabs"
          [connectionError]="
            bookWidgetFields.airportsField.fieldErrorInfo
              ?.connectionAirportField
          "
          [isFullscreen]="isFullscreen"
          [predictiveSearchData]="predictiveSearchData"
          [helpIconAriaLabel]="bookWidgetAem.helpIconAriaLabel"
          (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
          (searchModalEvent)="searchModalEvent.emit($event)"
          (showConnectionAirportInfoModal)="
            infoIconClickHandler(bookWidgetFieldInfoTypes.CONNECTION_AIRPORT)
          "
          (clearConnectionAirport)="clearConnectionAirport(i)"
        ></idp-connection-picker>
      </div>
    </div>
  </div>

  <div class="mc-mobile-container-row-3">
    <a
      *ngIf="bookWidgetFields.airportsField.showAddFlightBtn"
      class="mc-mobile-container-row-3__item mc-mobile-add-flight"
      href="javascript:void(0);"
      (click)="addFlight.emit()"
      machLink
    >
      <img
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/plus.svg"
        alt=""
      />
      {{ bookWidgetAem.airportsField.addFlight }}
    </a>

    <a
      *ngIf="bookWidgetFields.airportsField.showRemoveFlightBtn"
      class="mc-mobile-container-row-3__item mc-mobile-remove-flight"
      href="javascript:void(0);"
      (click)="removeFlight.emit()"
      machLink
    >
      <img
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/minus.svg"
        alt=""
      />
      {{ bookWidgetAem.airportsField.removeFlight }}
    </a>
  </div>

  <div class="mc-mobile-container-row-4">
    <div
      class="mc-mobile-container-row-4__item shop-miles-field"
      *ngIf="!bookWidgetFields.shopMilesField.hide"
    >
      <label
        for="shopMiles"
        class="field-label"
        [ngClass]="{
          'mach-checkbox-label-disabled':
            bookWidgetFields.shopMilesField.disable
        }"
      >
        {{ bookWidgetAem.shopMilesField.shopWithMiles }}
      </label>
      <mach-toggle
        id="shopMiles"
        [disabled]="bookWidgetFields.shopMilesField.disable"
        [selected]="bookWidgetFields.shopMilesField.checked"
        (toggled)="onToggleChange($event, bookWidgetFieldUpdateTypes.shopMiles)"
      ></mach-toggle>
    </div>
    <div
      class="mc-mobile-container-row-4__item basic-fares-field"
      *ngIf="!bookWidgetFields.basicFaresField.hide"
    >
      <label
        for="basicFaresField"
        class="field-label"
        [ngClass]="{
          'mach-checkbox-label-disabled':
            bookWidgetFields.basicFaresField.disable
        }"
      >
        {{ bookWidgetAem.includeBasicField.includeBasic }}
      </label>
      <mach-toggle
        id="basicFaresField"
        [disabled]="bookWidgetFields.basicFaresField.disable"
        [selected]="bookWidgetFields.basicFaresField.checked"
        (toggled)="
          onToggleChange($event, bookWidgetFieldUpdateTypes.basicFares)
        "
      ></mach-toggle>
    </div>
    <div
      class="mc-mobile-container-row-4__item refundable-fare-field"
      *ngIf="!bookWidgetFields.refundableFareField.hide"
    >
      <div class="refundable-fare-field-label-container">
        <label
          for="refundableFares"
          class="field-label"
          [ngClass]="{
            'mach-checkbox-label-disabled':
              bookWidgetFields.refundableFareField.disable
          }"
        >
          {{ bookWidgetAem.refundableFareField.refundableOnly }}
        </label>
        <img
          src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
          [attr.aria-label]="
            bookWidgetAem.refundableFareField.refundableOnly +
            ' ' +
            bookWidgetAem.helpIconAriaLabel
          "
          role="button"
          tabindex="0"
          (click)="
            infoIconClickHandler(bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY)
          "
          (keypress)="
            $event.key === 'Enter' &&
              infoIconClickHandler(
                bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
              )
          "
        />
      </div>
      <mach-toggle
        id="refundableFares"
        [disabled]="bookWidgetFields.refundableFareField.disable"
        [selected]="bookWidgetFields.refundableFareField.checked"
        (toggled)="
          onToggleChange($event, bookWidgetFieldUpdateTypes.refundableFare)
        "
      ></mach-toggle>
    </div>
  </div>

  <div class="mc-mobile-container-row-5">
    <div
      class="mc-mobile-container-row-5__item best-fare-options-field"
      *ngIf="!bookWidgetFields.bestFareOptionsField.hide"
    >
      <idp-best-fare-options
        [bookWidgetAem]="bookWidgetAem"
        [bookWidgetFields]="bookWidgetFields"
        (bestFareOptionsChange)="
          onDropdownSelectionChange(
            $event,
            bookWidgetFieldUpdateTypes.bestFareOptions
          )
        "
        [toolTipPosition]="'top-right'"
      ></idp-best-fare-options>
    </div>
    <div
      class="mc-mobile-container-row-5__item meeting-event-code-field"
      *ngIf="!bookWidgetFields.meetingEventCodeField.hide"
    >
      <idp-meeting-event-code
        [bookWidgetAem]="bookWidgetAem"
        [bookWidgetFields]="bookWidgetFields"
        (meetingEventCodeChange)="
          onInputFieldChange(
            $event,
            bookWidgetFieldUpdateTypes.meetingEventCode
          )
        "
        [toolTipPosition]="'top-right'"
      ></idp-meeting-event-code>
    </div>
    <div
      class="mc-mobile-container-row-5__item edocs-link"
      *ngIf="!bookWidgetFields.edocsLink.hide"
    >
      <a
        machLink
        [href]="bookWidgetFields.edocsLink.src"
        [linkDisabled]="bookWidgetFields.edocsLink.disable"
        [linkSize]="'small'"
        [innerHTML]="bookWidgetAem.edocsLink"
      ></a>
    </div>
  </div>

  <button
    id="findFilghtsCta"
    machButton
    class="find-flights-btn"
    [buttonSize]="'large'"
    [buttonColor]="'primary'"
    [buttonOutlineColor]="'primary'"
    (click)="findFlight.emit()"
  >
    {{ bookWidgetAem.searchBtn }}
  </button>
</div>
